import { GatsbyImage, getSrc } from 'gatsby-plugin-image';
import React from 'react';

import { styled } from '@mui/material/styles';

const ThumbRoot = styled('div')(({ theme }) => ({
  position: 'relative',
  '& .thumb-mask': {
    backgroundPosition: 'center center',
    backgroundSize: '101% 101%',
    bottom: 0,
    filter: 'grayscale(1)',
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    transition: `opacity ${theme.transitions.duration.standard}ms`,
    zIndex: 1,
    '&:hover': {
      opacity: 0,
    },
  },
}));

export default function Thumb({ image, ...restProps }) {
  return (
    <ThumbRoot>
      <div
        className="thumb-mask"
        style={{ backgroundImage: `url(${getSrc(image)})` }}
      />
      <GatsbyImage image={image} {...restProps} />
    </ThumbRoot>
  );
}
